import { Box, Button, Flex, Heading4, Modal, Text } from "@nulogy/components";
import React, { useState } from "react";
import ReadOnlyAvailabilityCheckbox from "./ReadOnlyAvailabilityCheckbox";

// HACK: This requires a 16px margin bottom, but we can't control the margin.
// Since there is already an 8px margin, we add 8px padding.
const Heading = ({ children: heading }) => <Heading4 paddingBottom="x1">{heading}</Heading4>;

const Item = ({ name, disabled, checked, overridden = false }) => (
  <Flex alignItems="center" paddingBottom="x2">
    <ReadOnlyAvailabilityCheckbox checked={checked} disabled={disabled} overridden={overridden} />
    <Text marginLeft="x2">{name}</Text>
  </Flex>
);

export default function AvailabilityOverridesLegend() {
  const [isLegendModalOpen, setLegendModalOpen] = useState(false);

  return (
    <>
      <Button data-testid="availability-legend-button" onClick={() => setLegendModalOpen(true)}>
        Legend
      </Button>
      <Modal
        ariaHideApp={false}
        isOpen={isLegendModalOpen}
        maxWidth="520px"
        onRequestClose={() => setLegendModalOpen(false)}
        title="Legend"
      >
        <Flex data-testid="availability-legend-statuses" justifyContent="space-between" marginBottom="x2">
          <Box>
            <Heading>Default Availability</Heading>
            <Item checked disabled={false} name="Available" />
            <Item checked={false} disabled={false} name="Unavailable" />
            <Item checked={false} disabled name="Inactive" />
          </Box>

          <Box>
            <Heading>Overridden Availability</Heading>
            <Item checked disabled={false} name="Overridden to available" overridden />
            <Item checked={false} disabled={false} name="Overridden to unavailable" overridden />
          </Box>
        </Flex>
      </Modal>
    </>
  );
}
